export const config = {
    backendUrl: "https://iprog.koda.re",
}